import { useBreakpointIndex } from "@theme-ui/match-media";
import React, { FC } from "react";
import StickyBox from "react-sticky-box";

interface ConditionalStickyBoxProps {
  children: React.ReactElement;
  offsetTop: number;
  offsetBottom?: number;
}

export const ResponsiveStickyBox: FC<ConditionalStickyBoxProps> = ({ children, offsetTop, offsetBottom = 20 }) => {
  const breakpoint = useBreakpointIndex();

  return breakpoint > 2 ? (
    <StickyBox style={{ zIndex: 1000 }} offsetTop={offsetTop} offsetBottom={offsetBottom}>
      {children}
    </StickyBox>
  ) : (
    children
  );
};
